export const NOT_AUTHORIZED_STATUS = [401, 403]
export const NOT_AUTHORIZED = "NotAuthorized"
export const MOBILE_BREAKPOINT = 780;